/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

/**
 * The grid item keys used in the Customer Profile screen.
 * @export
 */
export const CUSTOMER_PROFILE_GRID_ITEM_KEYS = {
  customerOverview: `CustomerOverview`,
  customerRecentEvents: `CustomerRecentEvents`,
  mappedAttributes: `MappedAttributes`,
  undefinedAttributes: `UndefinedAttributes`,
};

/**
 * The data-ids used in the Customer Profile screen.
 * @export
 */
export const CUSTOMER_PROFILE_DATA_IDS = {
  recentEventsEmptyState: `Recent events: No events`,
  viewAllAttributes: `Button: View all attributes`,
};

/**
 * The constant used for an empty value in the Customer Profile.
 * @export
 */
export const CUSTOMER_PROFILE_EMPTY_VALUE = `-`;
